// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"339":"1312c04b","491":"a581c0d9"}[chunkId] + ".css";
};